module.exports = __webpack_public_path__ + "img/video-call.8df31917.png";